import { viridisColor } from '@/lib/viridis';

interface HeatmapColorScaleProps {
  /** Position of zero on the 0..1 viridis ramp for the current color bounds. */
  zeroPosition: number;
}

export function HeatmapColorScale({ zeroPosition }: HeatmapColorScaleProps) {
  const zero = Math.max(0, Math.min(1, zeroPosition));
  const negative = `linear-gradient(90deg, ${viridisColor(0)}, ${viridisColor(zero)})`;
  const positive = `linear-gradient(90deg, ${viridisColor(zero)}, ${viridisColor((zero + 1) / 2)}, ${viridisColor(1)})`;

  return (
    <div className="flex flex-wrap items-center gap-2.5 pl-3 pt-2.5 text-xs text-fg min-[721px]:flex-nowrap min-[721px]:pl-2.5">
      <span>Strong Negative</span>
      <span
        className="h-[9px] w-[70px] rounded-[2px] min-[721px]:w-[140px]"
        style={{ background: negative }}
      />
      <span>0</span>
      <span
        className="h-[9px] w-[70px] rounded-[2px] min-[721px]:w-[140px]"
        style={{ background: positive }}
      />
      <span>Strong Positive</span>
    </div>
  );
}
